<div class="py-[100px] px-[50px] bg-white flex justify-between flex-wrap"
  [ngClass]="{'bg-green-50': plan === 'premium'}">
  <div>
    <h6 class="text-[var(--darkPurple)] py-5">
      <i class='bx bx-wallet-alt'></i>
      Plano em vigência
    </h6>

    <p [ngClass]="{
          'text-white bg-[--lightRed]': plan === 'free',
          'text-white bg-green-500': plan === 'premium'
        }" class="w-fit p-1 rounded-lg">
      <i class='bx bx-star'></i>
      {{ plan === 'premium' ? 'Plano Padrão' : 'Plano Gratuito' }}
    </p>

    <div *ngIf="plan === 'free'">
      <ul class="py-5 text-[--lightRed]">
        <li class="hidden">
          <i class='bx bxs-calendar'></i>
          Desde 21/04/2024
        </li>
        <li class="hidden">
          <i class='bx bx-label'></i>
          Cobrança todo dia 21
        </li>
        <li class="hidden">
          <i class='bx bx-money'></i>
          R$ 00,00
        </li>
      </ul>
    </div>

    <span *ngIf="plan === 'free'; else premiumMessage" [ngClass]="{ 'text-[--lightRedText]': true }">
      Faça o upgrade e tenha acesso a:
    </span>

    <ng-template #premiumMessage>
      <span [ngClass]="{ 'text-green-800': true }">
        Veja as vantagens do seu plano abaixo
      </span>
    </ng-template>

    <ul [ngClass]="{
          'text-[--lightRedText]': plan === 'free',
          'text-green-800': plan === 'premium'
        }" class="flex gap-4 flex-wrap py-2">
      <li><i class='bx bx-check-circle'></i> Mais de 1.000 questões filtradas por matéria</li>
      <li><i class='bx bx-check-circle'></i> Estatísticas de Desempenho</li>
      <li><i class='bx bx-check-circle'></i> Ranking de Alunos</li>
      <li><i class='bx bx-check-circle'></i> Questões Comentadas</li>
      <li><i class='bx bx-check-circle'></i> Grupo de Alunos no WhatsApp</li>
      <li><i class='bx bx-check-circle'></i> Simulados</li>
      <li><i class='bx bx-check-circle'></i> Questões</li>
      <li><i class='bx bx-check-circle'></i> Questões Únicas</li>
      <li><i class='bx bx-check-circle'></i> Estatísticas</li>
    </ul>
  </div>

  <div *ngIf="plan === 'free'" class="flex flex-col py-[50px] bg-[--lightRed] rounded-xl px-4 text-white w-[250px]">
    <i class='bx bxs-bell-ring text-center py-5 text-[50px]'></i>
    <span class="text-center">
      Você está utilizando um plano gratuito. <br><br>
      O que acha de dar um upgrade na sua assinatura?<br><br>
    </span>
    <button (click)="goToUpgrade()" class="p-2 text-[var(--darkPurple)] bg-yellow-400 rounded-md">
      Fazer upgrade
    </button>
  </div>
</div>